if (!customElements.get('review-image-gallery')) {
  customElements.define(
    'review-image-gallery',
    class ReviewImageGallery extends HTMLElement {
      constructor() {
        super();
        this.gallery = this.querySelector('slider-component');
        this.gallery.addEventListener('slideChanged', () => this.syncImageHeight());
        this.resizeObserver = new ResizeObserver(() => this.syncImageHeight());
        this.querySelectorAll('.kc-review-image-modal__slide').forEach((slide) => {
          slide.querySelector('img').addEventListener('load', () => this.syncImageHeight());
        });
        this.openObserver = new MutationObserver(() => this.onModalToggle());
        this.onViewportResize = () => {
          if (!this.modal?.hasAttribute('open')) return;
          const page = this.gallery.currentPage || 1;
          this.syncImageHeight();
          this.gallery.resetPages();
          const slide = this.gallery.sliderItems[page - 1];
          if (slide) this.gallery.slider.scrollTo({ left: slide.offsetLeft, top: 0, behavior: 'instant' });
          this.gallery.update();
        };
      }

      connectedCallback() {
        // Native modal-dialog moves to body before SliderComponent binds its buttons.
        this.modal = this.closest('modal-dialog');
        this.openObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
        this.querySelectorAll('.kc-review-image-modal__slide').forEach((slide) => this.resizeObserver.observe(slide));
        this.resizeObserver.observe(this.modal.querySelector('.kc-review-image-modal__intro'));
        this.resizeObserver.observe(this.modal.querySelector('.kc-review-image-modal__dialog'));
        window.addEventListener('resize', this.onViewportResize);
        window.visualViewport?.addEventListener('resize', this.onViewportResize);
        if (this.modal.hasAttribute('open')) this.onModalToggle();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onViewportResize);
        window.visualViewport?.removeEventListener('resize', this.onViewportResize);
        this.openObserver.disconnect();
        this.resizeObserver.disconnect();
        if (!document.querySelector('.kc-review-image-modal[open]')) document.body.classList.remove('kc-review-modal-open');
      }

      onModalToggle() {
        if (!this.modal.hasAttribute('open')) {
          document.body.classList.remove('kc-review-modal-open');
          return;
        }
        // The sticky header can remove the shared overflow class when it closes search.
        document.body.classList.add('kc-review-modal-open');
        this.gallery.resetPages();
        const opener = this.modal.openedBy;
        const slide = this.querySelector(`[data-media-key="${opener.dataset.mediaKey}"]`);
        this.gallery.slider.scrollTo({ left: slide.offsetLeft, top: 0, behavior: 'instant' });
        this.gallery.update();
        this.syncImageHeight();
        this.modal.querySelector('.kc-review-image-modal__content').scrollTop = 0;
      }

      syncImageHeight() {
        if (!this.modal?.hasAttribute('open')) return;
        // Reserve the visible toolbar area in theme previews on every screen size.
        const previewBar = document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect();
        const bottomInset = previewBar?.height > 0 && previewBar.top > window.innerHeight / 2
          ? Math.ceil(window.innerHeight - previewBar.top) : 0;
        this.modal.style.setProperty('--kc-review-modal-bottom-inset', `${bottomInset}px`);
        const content = this.modal.querySelector('.kc-review-image-modal__content');
        const intro = this.modal.querySelector('.kc-review-image-modal__intro');
        const contentStyle = getComputedStyle(content);
        const introStyle = getComputedStyle(intro);
        const controlsHeight = this.gallery.getBoundingClientRect().height - this.gallery.slider.getBoundingClientRect().height;
        const imageHeight = Math.max(80, Math.floor(
          parseFloat(contentStyle.maxHeight) - parseFloat(contentStyle.paddingTop) - parseFloat(contentStyle.paddingBottom)
          - intro.getBoundingClientRect().height - parseFloat(introStyle.marginTop) - controlsHeight
        ));
        const value = `${imageHeight}px`;
        if (content.style.getPropertyValue('--kc-review-image-height') !== value) {
          content.style.setProperty('--kc-review-image-height', value);
        }
        const slide = this.gallery.sliderItems[(this.gallery.currentPage || 1) - 1];
        if (slide) this.gallery.slider.style.height = `${slide.getBoundingClientRect().height}px`;
      }
    }
  );
}
